import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { adjustInventory } from "../../api/apiInventory";
import parseError from "../../utils/parseError";

export const useAdjustInventory = () => {
    const queryClient = useQueryClient();
    const { mutate: adjustInventoryMutate, isPending: isAdjusting } = useMutation({
        mutationFn: adjustInventory,
        onSuccess: (res) => {
            toast.success(res.message || "Stock adjusted");
            queryClient.invalidateQueries(["inventory"]);
            queryClient.invalidateQueries(["inventory-movements"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to adjust stock"),
    });
    return { adjustInventoryMutate, isAdjusting };
};
